/**
 * Reusable agency signature rendered at the very bottom of the site footer.
 * Subtle, centered, and readable on both light and dark footer backgrounds.
 */
export default function JttgDigitalCredit() {
  return (
    <div className="mx-auto mt-6 max-w-[1200px] border-t border-white/10 pt-5 pb-4 text-center">
      <p className="text-[11px] font-medium tracking-[0.12em] text-white/70 md:text-xs">
        Website Designed &amp; Powered by{" "}
        <a
          href="https://jttgdigital.com"
          target="_blank"
          rel="noopener noreferrer"
          className="font-semibold text-white/90 underline-offset-4 transition-colors duration-200 hover:text-white hover:underline"
        >
          JTTG Digital
        </a>
      </p>
    </div>
  );
}
